module.exports = __webpack_public_path__ + "static/img/bgmap2.eb033d9d.png";